import * as z from "zod";

import {
  savedStyleColorAttributesSchema,
  savedStyleTextAttributesSchema,
} from "./savedStyles";

export const savedColorStyleSchema = z
  .object({
    type: z.literal("color"),
    name: z.string(),
    attributes: savedStyleColorAttributesSchema,
    optionalUsageGuidelines: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    isPrimary: z.boolean().optional(),
  })
  .describe("SavedColorStyle");

export const savedTextStyleSchema = z
  .object({
    type: z.literal("text"),
    name: z.string(),
    attributes: savedStyleTextAttributesSchema,
    optionalUsageGuidelines: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    isPrimary: z.boolean().optional(),
  })
  .describe("SavedTextStyle");

export const designLibrarySavedStylesSchema = z
  .record(z.string(), z.union([savedColorStyleSchema, savedTextStyleSchema]))
  .describe("DesignLibrarySavedStylesMapping");

export const designLibrarySchema = z
  .object({
    id: z.uuid(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.coerce.date().nullish(),
    savedStyles: designLibrarySavedStylesSchema,
  })
  .describe("DesignLibrary");

export const designLibrarySavedStyleMetadataSchema = z
  .object({
    library: z.record(
      z.string(),
      z.object({
        styles: designLibrarySavedStylesSchema,
      }),
    ),
  })
  .describe("DesignLibrarySavedStyleMetadata");

export const globalsCssTokenSchema = z
  .object({
    name: z.string(),
    value: z.string(),
  })
  .describe("GlobalsCssToken");

export const globalsCssScopeSchema = z
  .object({
    selector: z.string(),
    tokens: z.array(globalsCssTokenSchema),
  })
  .describe("GlobalsCssScope");

export const globalsCssSnapshotSchema = z
  .object({
    scopes: z.array(globalsCssScopeSchema),
  })
  .describe("GlobalsCssSnapshot");

export const siteFontRoleSchema = z
  .object({
    role: z.string(),
    family: z.string().nullable(),
    cssVar: z.string().nullable(),
    rawValue: z.string(),
  })
  .describe("SiteFontRole");

export const siteFontsSnapshotSchema = z
  .object({
    roles: z.array(siteFontRoleSchema),
    defaultRole: z.string().nullable(),
  })
  .describe("SiteFontsSnapshot");

export const siteDesignLibraryStateSchema = z
  .object({
    siteId: z.uuid(),
    globalsCss: globalsCssSnapshotSchema.nullable(),
    fonts: siteFontsSnapshotSchema.nullable(),
    isLoading: z.boolean(),
    error: z.string().nullable(),
  })
  .describe("SiteDesignLibraryState");

export const DESIGN_LIBRARY_PREVIEW_MESSAGE_TYPE =
  "replo:design-library:applyOverrides";

export const designLibraryPreviewFontSchema = z
  .object({
    family: z.string(),
    cssVar: z.string(),
    faceUrl: z.string().optional(),
    format: z.string().optional(),
  })
  .describe("DesignLibraryPreviewFont");

export const designLibraryPreviewMessageSchema = z
  .object({
    type: z.literal(DESIGN_LIBRARY_PREVIEW_MESSAGE_TYPE),
    cssVars: z.record(z.string(), z.string()),
    fonts: z.array(designLibraryPreviewFontSchema),
    defaultFontCssVar: z.string().nullable(),
  })
  .describe("DesignLibraryPreviewMessage");
